import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CommonUtilitiesService {

    constructor() {}

    formatViewTime(timeInSeconds: number): string {
        const minutes = Math.floor(timeInSeconds / 60);
        const seconds = Math.floor(timeInSeconds % 60);

        return `${minutes}m${seconds}s`;
    }

    generateURLParameters(params: object): string {
        let urlParams = '';
        let count = 0;
        for (const key in params) {
            if (params.hasOwnProperty(key)) {
                urlParams += (count === 0 ? '?' : '&') + key + '=' + params[key];
                ++count;
            }
        }
        return urlParams;
    }

    getHolidays(year){
        const holidays = {
            2023: [
                '2023-01-02,',
                '2023-01-16,',
                '2023-02-20,',
                '2023-05-29,',
                '2023-06-19,',
                '2023-07-04,',
                '2023-09-04,',
                '2023-10-09,',
                '2023-11-10,',
                '2023-11-23,',
                '2023-12-25,',
            ]
        }

        if (holidays[year] && holidays[year] !== undefined){
            return holidays[year];
        }
        return [];
    }
}
